import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AccordionTopic from './AccordionTopic';

import { TOPIC, ARTICLE_LIST } from '../constants/PropTypesShapes';

class AccordionTopicGroup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTopic: props.activeTopic || {},
    };
    this.onToggle = this.onToggle.bind(this);
  }

  onToggle(topic, expanded) {
    this.setState({
      activeTopic: expanded ? topic : {},
    });
  }

  renderAccordians() {
    const parentTopic = {
      id: this.props.topics.articleId,
      articleTitle: this.props.topics.articleTitle,
    };
    return this.props.topics.articleList.map((topic) => {
      const expanded = this.state.activeTopic.id === topic.id;
      return (
        <section key={topic.id}>
          <AccordionTopic topic={topic} onToggle={this.onToggle} expanded={expanded} parent={parentTopic} />
        </section>
      );
    });
  }

  render() {
    return (
      <div className="topic-accordion-group">
        { this.renderAccordians() }
      </div>
    );
  }
}

AccordionTopicGroup.propTypes = {
  activeTopic: PropTypes.shape(TOPIC),
  topics: PropTypes.shape(ARTICLE_LIST).isRequired,
};

AccordionTopicGroup.defaultProps = {
  activeTopic: {},
};

export default AccordionTopicGroup;



// WEBPACK FOOTER //
// ./home/components/AccordionTopicGroup.js